module.exports = __webpack_public_path__ + "static/media/ok-icon.1e0cf52f.svg";